import {post} from '../interceptor'

let preUrl = '/extraDevice';
export default {
  getDeviceDetail(params) { return post(preUrl, '/getDeviceDetail', params) },
  getRealtimeData(params) { return post(preUrl, '/getRealtimeData', params) },
  getCurveDataById(params) { return post(preUrl, '/getCurveDataById', params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/extraDevice.js